module.exports = __webpack_public_path__ + "img/06-1.0e08e3a1.png";